export default __webpack_public_path__ + "static/media/img-06.dfff978c.png";